/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { GenericFormFields, GenericFormItemOptions } from '../interfaces';
import { get } from 'lodash';
import Autocomplete from '@material-ui/lab/Autocomplete';

const GenericFormAutocompleteField: React.FC<GenericFormFields> = ({
  item,
  fields,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const arrayValues = get(fields, item.stateKey, '');

  return (
    <div>
      <Autocomplete
        key={item.stateKey}
        getOptionLabel={option => option.label || ''}
        options={item.options!}
        multiple={item.isAutocompleteMultiple}
        id={item.stateKey}
        value={
          fields
            ? get(fields, item.stateKey, '')
            : get(values, item.stateKey, '')
        }
        onChange={(e: any, newValue: GenericFormItemOptions | null) => {
          if (setFieldValue) setFieldValue(item.stateKey, newValue);
          if (changeField)
            changeField({
              key: item.stateKey,
              value: newValue,
            });
        }}
        getOptionSelected={(option, value) => {
          if (item.isAutocompleteMultiple) {
            return arrayValues.some(item => item.value === option.value);
          } else {
            return option.value === value.value;
          }
        }}
        filterSelectedOptions
        disabled={item.disabled}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={item.label}
            fullWidth
            disabled={item.disabled}
            error={
              !!get(errors, item.stateKey, null) ||
              !!get(errors, item.error, null)
            }
            helperText={
              get(errors, item.stateKey, null) || get(errors, item.error, null)
            }
          />
        )}
      />
    </div>
  );
};

export default GenericFormAutocompleteField;
